import React, { useEffect, useState } from "react";
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader ,Card,CardBody} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useQueryClient,useQuery } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { useTranslation } from 'react-i18next';
import { Row, Col } from "reactstrap";
import 'filepond/dist/filepond.min.css';
import 'filepond/dist/filepond.min.css';
import { Steps } from 'antd';
import { createFormulaire, getFormulaire, updateFormulaire } from "../services/formulaireApi";
import ReactQuill from "react-quill";
import Formulaires from "../page";

const { Step } = Steps;

const AddEditFormulaireForm = ({ modal, setModal, toggle, selectedFormulaire  }) => {
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const { t } = useTranslation();
  const { isLoading, isError, error, data: formulaires=[] } = useQuery("formulaires", getFormulaire);
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Oups!!! Veuillez renseigner le nom"),
    category: Yup.string().required('Veuillez renseigner la catégorie de ce statut'),
    description: Yup.string().required("Une description serait idéale pour se retrouvée."),
    type: Yup.string().required("Un type serait idéale pour se retrouvée."),
    question: Yup.string().required("Une question serait idéale pour se retrouvée.")
  });

  const initialValues = selectedFormulaire ? {
    name: selectedFormulaire.name,
    category: selectedFormulaire.category,
    type: selectedFormulaire.type,
    question: selectedFormulaire.question,
    description: selectedFormulaire.description,
  } : {
    name: "",
    description: "",
    category:"",
    type:"",
    question:"",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoadingSubmit(true);
      try {
        
        if (selectedFormulaire) {
          await updateFormulaire(selectedFormulaire?.id, {...values});
          toast.success("La formulaire a été modifié avec succès 🎉");
        } else {
          await createFormulaire({...values});
          toast.success("La formuaire a été créé avec succès 🎉");
        }

        await queryClient.invalidateQueries("roles");
        toggle();
        formik.resetForm({ values: initialValues }); 

      } catch (error) {
        toast.error(`😌 Erreur: ${error?.message || error}`);
      } finally {
        setIsLoadingSubmit(false);
      }
    },
  });
  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedFormulaire]);
// Filtrer les catégories uniques par leur nom
const uniqueCategories = Array.isArray(formulaires)
  ? [...new Set(formulaires.map((cat) => cat.category))]
  : [];
  const uniqueTypes = Array.isArray(formulaires)
  ? [...new Set(formulaires.map((typ) => typ.type))]
  : [];
  const modalTitle = selectedFormulaire ? t("formulaire.edit") : t("formulaire.add");
  return (
    <div className="" style={{ borderRadius: '8px' }}>
      <Modal
        id="showModalClient"
        isOpen={modal}
        toggle={toggle}
        centered
        backdrop={"static"}
        style={{
          maxWidth: "1440px",
          maxHeight: "1073px",
          top: '32px',
        }}
      >
        <Form onSubmit={formik.handleSubmit}>
          <ModalHeader className="d-flex justify-content-center align-items-center p-3">
            <h3 className="text-center" style={{ color: '#252525', fontFamily: 'Raleway', fontSize: '22px', fontWeight: 'bold' }}>
              {modalTitle}      
            </h3>
          </ModalHeader>
         <Col  className="d-flex justify-content-end gap-2 mt-3 mt-n5">
         <Button className="bordered-btn-lightR "color="light" onClick={() => setModal(false)}>
              {t("driverForm.cancel")}
            </Button>
        </Col>
          <ModalBody className="modal-body d-flex justify-content-center">
            <Card style={{ borderRadius: '8px', width: '60%', padding: '20px' }}>
              <CardBody>
                <Row className="justify-content-center">
                  <Col md={12}>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label"style={{ color: '#6C6B6B', fontFamily: 'Inter', fontWeight: '400px', fontSize: '14px' }}>
                        Titre <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Veuillez renseigner le nom du formulaire à créer"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                        required
                      />
                      {formik.touched.name && formik.errors.name && (
                        <div className="text-danger">{formik.errors.name}</div>
                      )}
                    </div>
                  </Col>
                </Row>
             
    
                <Row className="justify-content-center">
                  <Col md={6}>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label"style={{ color: '#6C6B6B', fontFamily: 'Inter', fontWeight: '400px', fontSize: '14px' }}>
                        Category <span className="text-danger">*</span>
                      </label>
                      <select
                            id="category"
                          name="category"
                          className="form-control"
                          onChange={(e) => formik.setFieldValue("category", e.target.value)} // ✅ Correction ici
                          value={formik.values.category}
                          disabled={isLoading}
                        >
                      <option value="">-- Sélectionnez une catégorie --</option>
                      {uniqueCategories.length > 0 ? (
                        uniqueCategories.map((category, index) => (
                          <option key={index} value={category}>
                            {category}
                          </option>
                        ))
                      ) : (
                        <option disabled>Chargement...</option>
                      )}
            </select>

                      {formik.touched.name && formik.errors.category && (
                        <div className="text-danger">{formik.errors.category}</div>
                      )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <label htmlFor="type" className="form-label"style={{ color: '#6C6B6B', fontFamily: 'Inter', fontWeight: '400px', fontSize: '14px' }}>
                        Type <span className="text-danger">*</span>
                      </label>
                      <select
                        id="type"
                        name="type"
                        className="form-control"
                        onChange={(e) => formik.setFieldValue("type", e.target.value)} // ✅ Correction ici
                        value={formik.values.type}
                        disabled={isLoading}
                      >
                        <option value="">-- Sélectionnez un type --</option>
                        {uniqueTypes.length > 0 ? (
                          uniqueTypes.map((type, index) => (
                            <option key={index} value={type}>
                              {type}
                            </option>
                          ))
                        ) : (
                          <option disabled>Chargement...</option>
                        )}
          </select>

                      {formik.touched.type && formik.errors.type && (
                        <div className="text-danger">{formik.errors.type}</div>
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="justify-content-center">
      <Col md={12}>
        <label className="form-label"style={{ color: '#6C6B6B', fontFamily: 'Inter', fontWeight: '400px', fontSize: '14px' }}>Questions</label><span className="text-danger">*</span>
        <ReactQuill
              value={formik.values.question}
              onChange={(content, delta, source, editor) => {
                formik.setFieldValue("question",content); // 🔥 Récupère seulement le texte
              }}
              modules={{
                toolbar: [
                  ["bold", "italic", "underline"],
                  ["blockquote"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["link"],
                  [{ align: [] }],
                ],
              }}
              theme="snow"
              placeholder="Écrivez votre question ici..."
            />


      </Col>
    </Row>
                <Row className="justify-content-center">
                  <Col md={12}>
                    <div className="mb-3">
                      <label htmlFor="description" className="form-label" style={{ color: '#6C6B6B', fontFamily: 'Inter', fontWeight: '400px', fontSize: '14px' }}>
                        Instruciton
                      </label><span className="text-danger">*</span>
                      <textarea
                        id="description"
                        name="description"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.description}
                        rows="4"
                        style={{ border: '1px solid #D9D9D9' }}
                      />
                      {formik.touched.description && formik.errors.description && (
                        <div className="text-danger">{formik.errors.description}</div>
                      )}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </ModalBody>
          <Row className="justify-content-center">
          <Col md={5}>
                 <Button  style={{
                        borderRadius: '20px',
                        marginRight: '100px',
                        border: '2px #151515',
                        width: '100%',
                        }}type="submit" className="bordered-btn" disabled={isLoadingSubmit}>
                        {isLoadingSubmit ? <Spin size="small" /> : selectedFormulaire ? t("rappels.edit") : t("rappels.add")}
                      </Button>
              </Col>
          </Row>
            <ModalFooter>
              <div className="d-flex justify-content-end gap-2 mt-3">
              </div>
            </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
  
};
export default AddEditFormulaireForm;

